<template>
      <!-- WEIGHT CHART -->
        <base-material-chart-card
          v-if="weightDiary"
          :data="weightData"
          :options="weightChart.options"
          color="#06948a"
          hover-reveal
          type="Line"
          id="weight-chart"
        >
          <h4 class="card-title font-weight-light mt-2 ml-2 text-center">
            Weight Overview
          </h4>

          <v-row class="mt-6">
            <v-col>
              <base-stat title="Start Weight" :text="profile.w" :footer="profile.u" color="#7d7d7d" />
            </v-col>
            <v-col>
              <base-stat title="Current Weight" :text="profile.c" :footer="profile.u" color="#f9b223" />
            </v-col>
            <v-col>
              <base-stat title="Goal Weight" :text="profile.g" :footer="profile.u" color="#06948a" />
            </v-col>
          </v-row>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-icon
              class="mr-1"
              small
            >
              mdi-trophy-outline
            </v-icon>
            <span class="caption grey--text font-weight-light" v-text="stepGoal"></span>
          </template>
        </base-material-chart-card>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import _ from 'lodash';
  var moment = require('moment');

  export default {
    name: 'DashboardDashboard',

    data () {
      return {
      }
    },

    methods: {
      ...mapActions('Diary', ['subscribeToWeightDiary']),
    },
    computed: {
      ...mapState('Diary', ['weightDiary']),
      ...mapState('Profile', ['profile','currentDiet']),
      ...mapGetters('Profile', ['stepGoals']),
      chunkedWeights() {
        return _.chunk(this.weightDiary.map(a => a.w), Math.ceil(this.weightDiary.length / 10)).map(c => _.mean(c));
      },
      goalweight() {
        return this.profile ? this.profile.g : 0
      },
      startweight() {
        return this.profile ? this.profile.w : 0
      },
      stepGoal() {
        if (this.weightDiary.length <= 0) return 'Error calculating current step'
        const lost = this.profile.w - ((this.weightDiary.length > 0) ? this.weightDiary.slice(-1)[0].w : 0);
        let step = this.stepGoals.find(el => el.g > lost);

        // We found the step
        if (step) {
          return `${step.n} - Goal ${step.g}${this.profile.u} (${(step.g-lost).toFixed(1)}${this.profile.u} to go)`;
        }
        
        // Past goal weight
        if (!step && this.weightDiary.length > 0)
        {
          // Just get the last one
          step = this.stepGoals.slice(-1)[0]
          return `${step.n} - Goal ${step.g}${this.profile.u}`; 
        }
        
        return 'Error calculating current step'
      },
      weightData() {
        const weightArray = this.chunkedWeights;
        const dateArray = _.chunk(this.weightDiary.map(a => moment(a.d).format('D MMM')), Math.ceil(this.weightDiary.length / 10)).map(d => d[0]);

        const data = {
            labels: dateArray,
            series: [
              { 
                data: new Array(weightArray.length).fill(this.startweight),
                name: 'startweight'  
              },
              { 
                data: new Array(weightArray.length).fill(this.goalweight),
                name: 'goalweight'
              }, 
              { 
                data: weightArray,
                name: 'weight'  
              }
            ]}
        return data;
      },
      weightChart() {
        return {
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0,
            }),
            axisY: {
              labelInterpolationFnc: function(value) {
                return `${value}kg`
              }
            },
            low: _.min(this.chunkedWeights, this.goalweight, this.startweight)-10,
            high: _.max(this.chunkedWeights, this.goalweight, this.startweight), // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            },
            series: {
              'startweight' : {
                showPoint: false,
                showArea: true,
                showLine: true,
              },
              'goalweight' : {
                showPoint: false,
                showArea: false
              },
              'weight' : {
                showArea: false
              }
            }
          },
        }
      },
    },
    mounted: function() {
      // In case the data isn't there - check done in the store
      this.subscribeToWeightDiary();
    }
  }
</script>
<style >

#weight-chart .ct-series-a .ct-line {
   /* stroke: rgba(125, 125, 125, 1); */
   stroke: #fff;
   stroke-width: 1;
   stroke-dasharray: 5;
}
#weight-chart .ct-series-b .ct-line {
   stroke: #fff;
   stroke-width: 1;
   stroke-dasharray: 5;
}
#weight-chart .ct-series-c .ct-car, #weight-chart .ct-series-c .ct-line, #weight-chart .ct-series-c .ct-point, #weight-chart .ct-series-c .ct-slice-donut {
   stroke: #fff;
}


.ct-series-a .ct-bar {
   stroke-width: 20;
}
</style>